(function () {
  var mapSelector = '[data-sy-google-map]';
  var apiPromiseKey = '__syGoogleMapsApiPromise';
  var callbackName = '__syGoogleMapsApiReady';

  function loadGoogleMaps(apiKey) {
    if (window.google && window.google.maps) {
      return Promise.resolve(window.google.maps);
    }

    if (!window[apiPromiseKey]) {
      window[apiPromiseKey] = new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        var params = new URLSearchParams({
          key: apiKey,
          language: 'ja',
          loading: 'async',
          callback: callbackName
        });

        window[callbackName] = function () {
          delete window[callbackName];
          resolve(window.google.maps);
        };

        script.async = true;
        script.src = 'https://maps.googleapis.com/maps/api/js?' + params.toString();
        script.onerror = function () {
          delete window[callbackName];
          reject(new Error('Google Maps JavaScript API could not be loaded.'));
        };
        document.head.appendChild(script);
      });
    }

    return window[apiPromiseKey];
  }

  function initializeMap(element) {
    if (element.dataset.syGoogleMapInitialized === 'true') return;

    var apiKey = element.dataset.apiKey;
    if (!apiKey) return;

    element.dataset.syGoogleMapInitialized = 'true';
    loadGoogleMaps(apiKey)
      .then(function (maps) {
        if (!element.isConnected) return;

        var position = new maps.LatLng(
          Number(element.dataset.latitude) || 0,
          Number(element.dataset.longitude) || 0
        );
        var map = new maps.Map(element, {
          zoom: Number(element.dataset.zoom) || 15,
          center: position,
          draggable: true,
          zoomControl: true,
          mapTypeId: 'roadmap',
          mapTypeControl: false
        });
        var markerOptions = { position: position, map: map };

        if (element.dataset.iconUrl) {
          var iconWidth = Number(element.dataset.iconWidth) || 60;
          var iconHeight = Number(element.dataset.iconHeight) || iconWidth;
          markerOptions.icon = {
            url: element.dataset.iconUrl,
            scaledSize: new maps.Size(iconWidth, iconHeight),
            anchor: new maps.Point(iconWidth / 2, iconHeight)
          };
        }

        new maps.Marker(markerOptions);
      })
      .catch(function (error) {
        element.dataset.syGoogleMapInitialized = 'false';
        console.error(error);
      });
  }

  function initializeMaps(root) {
    if (root.matches && root.matches(mapSelector)) initializeMap(root);
    root.querySelectorAll(mapSelector).forEach(initializeMap);
  }

  initializeMaps(document);
  document.addEventListener('shopify:section:load', function (event) {
    initializeMaps(event.target);
  });
})();
